import { render, staticRenderFns } from "./CRMContacts.vue?vue&type=template&id=0872567f&scoped=true&"
import script from "./CRMContacts.vue?vue&type=script&lang=js&"
export * from "./CRMContacts.vue?vue&type=script&lang=js&"
import style0 from "./CRMContacts.vue?vue&type=style&index=0&id=0872567f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0872567f",
  null
  
)

export default component.exports